import React from 'react';

import InitialReportPage from './initialReportPage';

const reportPageProps = {
  sessionStorageName: 'landing-requests-page-data',
  pageTitle: 'Pilot Landing Requests',
  stateName: 'pilotLandingRequests',
  actionName: 'getPilotLandingRequestsList',
  default_sort_column: 'id',
};

const LandingRequestsPage = () => (
  <InitialReportPage reportPageProps={reportPageProps} show_listings />
);

export default LandingRequestsPage;
